//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import InspectionTemplateDrawer from "./modules/InspectionTemplateDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
export default {
  name: 'InspectionTemplateList',
  mixins: [JeecgListMixin],
  components: {
    InspectionTemplateDrawer: InspectionTemplateDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/inspection/template',
      pageTitle: '巡检模板',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '模板编号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '模板名称',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'category',
        colName: 'category',
        title: '模板类型',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'isGps_dictText',
        colName: 'is_gps',
        title: '巡检轨迹',
        align: 'center',
        sorter: false
      },
      /* {
         dataIndex: 'coordinate',
         colName: 'coordinate',
         title: '模板坐标集',
         align: 'center',
         sorter: false
       },*/
      {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '模板状态',
        align: 'center',
        sorter: false
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      console.log(ids[1], ids[0]);

      if (ids[0] == 1) {
        // 根据站点id
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.spliceColumn(this.siteColumn, 1);
      }

      this.loadData();
    }
  },
  created: function created() {},
  computed: {},
  methods: {}
};